define([], function () {
  var SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple'];

  return {
    SUPPORTED_SOCIAL_IDPS,
  };
});



// WEBPACK FOOTER //
// ./src/util/IDP.js